import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  PlanMarketResponse,
  PlanSummaryResponse,
} from '../../Interfaces/api/backoffice/plan.interface';

export class PlanSummary {
  id = '';
  code: string | null = null;
  name: string | null = null;
  version = 1;
  is_active = false;
  organization_id: string | null = null;
  market: PlanMarketResponse | null = null;
  subscriber_count = 0;
  created_at: string | null = null;
  updated_at: string | null = null;
  feature_keys: string[] = [];

  constructor(data: Partial<PlanSummaryResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.code || this.id;
  }

  get currency(): string | null {
    return this.market?.currency ?? null;
  }

  get marketLabel(): string {
    return this.market?.name || this.market?.code || VALUE_UNRESOLVED;
  }
}
